import { Button, Flex, Group, Text, TextInput, TextInputProps } from '@mantine/core';
import {
  IconCalendarEvent,
  IconChevronLeft,
  IconChevronRight,
  IconCircleX
} from '@tabler/icons-react';
import { DatePickerProps } from 'react-datepicker';

import { plum } from '@/styles/colors';

import 'react-datepicker/dist/react-datepicker.css';

import styles from './DatePickerSubcomponents.module.scss';

export const DatePickerHeader: DatePickerProps['renderCustomHeader'] = ({
  date,
  decreaseMonth,
  increaseMonth
}: {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
}) => {
  const monthName = date.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });

  return (
    <Flex align="center" justify="space-between" mb="lg">
      <Button variant="transparent" p={0} aria-label="Previous Month" onClick={decreaseMonth}>
        <IconChevronLeft />
      </Button>
      <Text fw="regular">{monthName}</Text>
      <Button variant="transparent" p={0} aria-label="Previous Month" onClick={increaseMonth}>
        <IconChevronRight />
      </Button>
    </Flex>
  );
};

export interface DatePickerInputProps extends TextInputProps {
  setCalenderOpen: (v: boolean) => void;
  onClear?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  selected?: Date | null;
  isClearable?: boolean;
  styles?: Record<string, string>;
}

export const DatePickerInput = (props: DatePickerInputProps) => {
  const {
    setCalenderOpen,
    disabled,
    onClear,
    selected,
    isClearable,
    styles: overridenStyles,
    ...restProps
  } = props;
  const showClearIcon = isClearable && onClear && selected;

  const clearIcon = () => {
    if (!showClearIcon) return null;
    return (
      <Button
        variant="transparent"
        p={0}
        aria-label="Previous Month"
        disabled={disabled}
        onClick={onClear}>
        <IconCircleX color={plum[5]} size={18} />
      </Button>
    );
  };

  const calendarIcon = () => {
    return (
      <Button
        variant="transparent"
        p={0}
        aria-label="Previous Month"
        disabled={disabled}
        pr={4}
        onClick={() => setCalenderOpen(true)}>
        <IconCalendarEvent color={plum[5]} size={18} />
      </Button>
    );
  };

  const rightSection = () => {
    return (
      <Group justify={'flex-end'} w={'100%'} align="center" gap={4}>
        {clearIcon()}
        {calendarIcon()}
      </Group>
    );
  };

  return (
    <TextInput
      disabled={disabled}
      rightSectionWidth={showClearIcon ? 60 : 30}
      classNames={{
        input: overridenStyles?.input,
        section: styles.section,
        label: overridenStyles?.label ?? styles.label
      }}
      rightSection={rightSection()}
      {...restProps}
    />
  );
};
